
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates/[category]",
      function () {
        return require("private-next-pages/templates/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/templates/[category]"])
      });
    }
  